import React from 'react';
import { Empty } from 'antd';
import formatDuration from '../../../utils/formatDuration';
import TaskRow from './TaskRow';
import type { PlanGroup, PlanTask } from '../../../types/plan';

type GroupedTaskListProps = {
  groups: PlanGroup[];
  onQuickSchedule: (task: PlanTask, when: 'today' | 'tomorrow') => void;
  onToggle: (task: PlanTask) => void;
  onEdit: (task: PlanTask) => void;
};

const GroupedTaskList: React.FC<GroupedTaskListProps> = ({
  groups,
  onQuickSchedule,
  onToggle,
  onEdit,
}) => {
  const visible = groups.filter((group) => group.stats.total > 0);

  if (visible.length === 0) {
    return <Empty description="这个维度下没有未完成的任务" className="py-10" />;
  }

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
      {visible.map((group) => (
        <div key={group.key} className="rounded-xl border border-gray-200 bg-gray-50/60 p-3">
          <div className="mb-3 flex items-baseline justify-between">
            <span className="text-sm font-semibold text-gray-900">{group.label}</span>
            <span className="text-xs text-gray-500">
              {group.stats.total} 项 · 预估 {formatDuration(group.stats.estimated_minutes)}
            </span>
          </div>

          {group.tasks.map((task) => (
            <TaskRow
              key={task.id}
              task={task}
              draggable={false}
              showQuickSchedule
              onQuickSchedule={onQuickSchedule}
              onToggle={onToggle}
              onEdit={onEdit}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default GroupedTaskList;
